import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Message = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M20 6C12.268 6 5.99999 12.268 5.99999 20C5.99999 22.2582 6.53391 24.3888 7.48148 26.2752L7.62341 26.5501L7.62419 26.5516L7.62691 26.5568C7.73366 26.7636 7.76499 27.0011 7.71549 27.2284L6.35211 33.4903L11.6438 31.7111C11.9487 31.6085 12.2843 31.659 12.5457 31.8466C12.6576 31.927 12.7833 32.0011 12.9573 32.1024L12.9633 32.1059C12.9632 32.1059 12.9634 32.106 12.9633 32.1059C15.0299 33.3099 17.433 34 20 34C27.732 34 34 27.732 34 20C34 12.268 27.732 6 20 6ZM5.68482 27.1541C4.60641 25.0001 3.99999 22.5695 3.99999 20C3.99999 11.1634 11.1634 4 20 4C28.8365 4 36 11.1634 36 20C36 28.8366 28.8365 36 20 36C17.0697 36 14.3205 35.2113 11.9565 33.834L11.936 33.8221C11.902 33.8023 11.8659 33.7813 11.8282 33.7591L5.3187 35.9479C4.9775 36.0626 4.60097 35.9851 4.33282 35.7449C4.06468 35.5047 3.9463 35.139 4.02289 34.7873L5.68482 27.1541ZM14 16C14 15.4477 14.4477 15 15 15H25C25.5523 15 26 15.4477 26 16C26 16.5523 25.5523 17 25 17H15C14.4477 17 14 16.5523 14 16ZM14 23C14 22.4477 14.4477 22 15 22H23C23.5523 22 24 22.4477 24 23C24 23.5523 23.5523 24 23 24H15C14.4477 24 14 23.5523 14 23Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Message;
